/**
 * SPDX-FileCopyrightText: © 2014 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: LGPL-3.0-or-later
 */

import ToolbarAdd from './toolbar-add.jsx';
import ToolbarStyles from './toolbar-styles.jsx';

export default {
	[ToolbarAdd.key]: ToolbarAdd,
	[ToolbarStyles.key]: ToolbarStyles,
};
